<template>
  <div>
    <div class="layer-query">
      <input placeholder="可输入用户名称/用户编码/手机号码搜索" class="layer-query-input" v-model="layerQueryInput" />
      <button class="layer-query-button" @click="layerQuery"></button>
    </div>
  </div>
</template>

<script>


export default {
  name: 'layerQueryMap',
  data () {
    return {
      layerQueryUrl: '/smart-water-major-users/major/users/user/user/all/list/tenant/one',
      layerQueryInput: '',
    }
  },
  methods: {
    layerQuery () {
      this.$http.get(this.layerQueryUrl, {
        params: {
          selectString: this.layerQueryInput,
        }
      }).then((res) => {
        console.log(res)
        this.$emit('layerQuery', res.data)

      })
    }
  }
}
</script>

<style lang="less" scoped>
.layer-query {
  width: 450px;
  height: 40px;
  background: url(~@/assets/bigusers/largeScreen/layerQuery.png) no-repeat;
  background-size: 100% 100%;
  padding: 0 20px;
  display: flex;
  align-items: center;

  /* 垂直居中 */
  .layer-query-input {
    width: 350px;
    border: none;
    height: 40px;
    background: none;
    color: white;

  }

  .layer-query-input:focus {
    outline: none;
  }

  .layer-query-input::placeholder {
    color: #A9D4FB;
  }

  .layer-query-button {
    cursor: pointer;
    width: 61px;
    height: 31px;
    border: none;
    background: url(~@/assets/bigusers/largeScreen/layerQueryButton.png) no-repeat;
    background-size: 100% 100%;
  }

  .layer-query-button:hover {
    background: url(~@/assets/bigusers/largeScreen/layerQueryHighlight.png) no-repeat;
    background-size: 100% 100%;
  }

}
</style>